import { useAccountCompanyId } from 'application/hooks';
import { useSubscriptionCostPresenter } from 'application/presenters';
import { useExtendSubscription, useLaunchSubscription, useUserBillingInfo } from '@entities/billing';

import { PaymentKind } from '@shared/api/graphql/generated';

const useExtendSubscriptionModalPresenter = () => {
  const companyId = useAccountCompanyId();

  const { getSubscriptionCost } = useSubscriptionCostPresenter();

  const { watchBillingInfo } = useUserBillingInfo();

  const { request: extendSubscriptionRequest, result: extendSubscriptionResult } = useExtendSubscription();
  const { request: launchSubscriptionRequest, result: launchSubscriptionResult } = useLaunchSubscription();

  const licenseSubscriptionLoading = extendSubscriptionResult.loading || launchSubscriptionResult.loading;

  const billingInfo = watchBillingInfo(companyId);

  const { hasInactiveLicenses, selectedPaymentKind } = billingInfo;

  const extendSubscription = async (toExtendSubscriptionLicenseIds: string[]) => {
    const result = await extendSubscriptionRequest(companyId, toExtendSubscriptionLicenseIds);

    return result;
  };

  const launchSubscription = async (toExtendSubscriptionLicenseIds: string[]) => {
    const result = await launchSubscriptionRequest(companyId, toExtendSubscriptionLicenseIds);

    return result;
  };

  return {
    hasInactiveLicenses,
    getSubscriptionCost,
    licenseSubscriptionLoading,
    isSbbolPayment: selectedPaymentKind === PaymentKind.Sbbol,
    extendSubscription,
    launchSubscription,
  };
};

export default useExtendSubscriptionModalPresenter;
